import { Component, Vue } from "vue-property-decorator";

import { Loading, Hint } from "@/components";
import { LoginModel } from "@/models";
import { TCBReceiptApi } from "@/network/pb/proto";
import * as CryptoJS from 'crypto-js'

@Component<LoginForgetController>({
    components: {
        Loading,
        Hint,
    },
})
export default class LoginForgetController extends Vue {
    private isLoading = true;
    private doubleClick = false;

    private login = TCBReceiptApi.Protobuf.Login.create();
    private errMsg: {
        identification: string,
        account: string,
    } = {
        identification: "",
        account: "",
    };

    // Hint
    private hintBox: {show: boolean, hint: string} = {show: false, hint: ""};

    public async created() {
        this.isLoading = false;
    }

    private async checkAndSubmit() {
        let isEmpty = false;
        this.errMsg.identification = "";
        this.errMsg.account = "";

        if (this.login.identification === "") {
            this.errMsg.identification = "必填";
            isEmpty = true;
        }
        if (this.login.account === "") {
            this.errMsg.account = "必填";
            isEmpty = true;
        }

        if (isEmpty) return false;

        await this.submit();
    }

    private async submit() {
        if (!this.doubleClick) {
            this.doubleClick = true;

            /* send value */
            this.isLoading = true;

            const item = this.login as TCBReceiptApi.Protobuf.Login;
            item.account = CryptoJS.SHA256(this.login.account).toString();
            console.log(item);
            const loginQuery = TCBReceiptApi.Protobuf.Login.encode(item).finish();
            const errorCode = await LoginModel.forget(loginQuery);
            console.log(errorCode);
            if (errorCode === TCBReceiptApi.Protobuf.ErrorCode.EC_SUCESS) {
                this.openHint("已送出密碼重置信至您的信箱");
                this.login.account = "";
            } else {
                this.errMsg.identification = "特店代號/統編錯誤";
                this.errMsg.account = "使用者代號錯誤";
                this.login.account = "";
            }

            this.isLoading = false;
            /* send value */

            this.doubleClick = false;
        }
    }

    /* Hint */
    private openHint(hint: string) {
        this.hintBox.show = true;
        this.hintBox.hint = hint;
    }

    private closeHint() {
        this.hintBox.show = false;
        this.hintBox.hint = "";
        this.$router.push("/login");
    }
    /* Hint */
}